var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-item-base"},[_c('div',{staticClass:"stream-item-line",style:(_vm.lineStyles)}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }